// The order of a resume's sections: `content.settings.section_order`, one list for the whole resume. It starts with `basics` (the header: name,
// photo and contact details), which is always first and cannot be moved or hidden (ResumeContent keeps it there on the server too). What follows
// are the sections the resume draws, top to bottom: the built in ones and the user's own, by id.
//
// The Section order form, the Design panel, the section icons beside the form and the preview all read and write this one list.

export const PINNED_SECTION = 'basics'
// Two forms beside the sections are picked from the section icons like a section, under these keys. They are not sections of the resume: one arranges and hides the sections, the other is the look (template, colour, font, size, spacing).
export const ORDER_KEY = 'order'
export const DESIGN_KEY = 'design'
// The built in sections a new resume shows after basics, in this order (ResumeContent::SECTION_KEYS): projects right after experience, then education, certifications, skills and languages.
export const SECTION_KEYS = ['summary', 'experience', 'projects', 'education', 'certifications', 'skills', 'languages']

// The sections that can be moved, in order.
export const movableKeys = (order) => (Array.isArray(order) ? order.filter((key) => key !== PINNED_SECTION) : [])

// The whole list for a new arrangement of the movable sections: basics first, then each section once.
export const withPinned = (keys) => [PINNED_SECTION, ...new Set(keys.filter((key) => key !== PINNED_SECTION))]

// A new array with the section at `from` moved to `to` (both positions among the movable sections). Out of range moves change nothing.
export function moveKey(keys, from, to) {
  if (from === to || from < 0 || to < 0 || from >= keys.length || to >= keys.length) return [...keys]

  const next = [...keys]
  const [key] = next.splice(from, 1)
  next.splice(to, 0, key)
  return next
}

// Every section of the resume after basics, top to bottom: the order it holds, then any section it does not name yet (a resume saved before a
// section existed). The section icons and the Section order form list these.
export function sectionKeys(content) {
  const known = [...SECTION_KEYS, ...content.custom.map((section) => section.id)]
  const order = movableKeys(content.settings.section_order).filter((key) => known.includes(key))
  return [...new Set([...order, ...known])]
}
